import errors from './errors';
import messages from './messages';

export default {
    mixins: [errors, messages],
    methods: {
        toast(type, message, options) {

            let error = options instanceof Error ? options : null;

            options = _.merge({
                duration: 3000,
                type: `is-${type}`
            }, options);

            switch (type) {
                case 'error':
                    {
                        options.position = "is-bottom";
                        options.type = "is-danger";
                        break;
                    }
            }

            if (message) {
                if (message.substring(0, 1) != '@') {
                    options.message = message;
                } else {
                    message = message.substring(1);
                    let path = `${type}.${message}`;
                    message = _.get(this.messages, path);
                    options.message = message || path;
                }

                if (
                    (
                        process.env.NODE_ENV == 'production' ||
                        process.env.MIX_BUGSNAG_DEBUG
                    ) && type == 'error'
                ) {
                    if (error) {
                        this.report(error)
                    } else {
                        this.report(message)
                    }
                }

                let code = _.get(options, 'response.status');

                if(code != undefined) {
                    options.message += ` (${code})`;
                }

                return this.$toast.open(options);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/mixins/toasts.js